import type { Locale } from 'antd/es/locale';
import enUS from 'antd/locale/en_US';
import arEG from 'antd/locale/ar_EG';
import hiIN from 'antd/locale/hi_IN';
import esES from 'antd/locale/es_ES';
import frFR from 'antd/locale/fr_FR';
import deDE from 'antd/locale/de_DE';
import type { OrdanLanguageCode } from './languageRegistry';

const MAP: Record<OrdanLanguageCode, Locale> = {
  en: enUS,
  ar: arEG,
  hi: hiIN,
  es: esES,
  fr: frFR,
  de: deDE,
};

export function getAntdLocale(code: string): Locale {
  return MAP[(code as OrdanLanguageCode) in MAP ? (code as OrdanLanguageCode) : 'en'];
}
